import { SupabaseClient } from '@supabase/supabase-js';

export const deleteBroker = async (
  supabase: SupabaseClient,
  brokerId: number
) => {
  const { error } = await supabase.from('brokers').delete().eq('id', brokerId);
  if (error) console.error(error);
  return { error };
};
